import { Injectable, Type } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import Swal from 'sweetalert2';

const initModal: any = {
  formulario: '',
  title: '',
  data: {},
};

const tipo: string = '';

@Injectable({
  providedIn: 'root',
})
export class ModalService {
  ngAfterContentInit(): void {
    throw new Error('Method not implemented.');
  }
  //Behaviors Subjects

  private readonly FormModal$ = new BehaviorSubject<any>(initModal);
  private readonly Tipo$ = new BehaviorSubject<string>(tipo);

  private registry = new Map<string, Type<any>>();

  private popstateListener?: () => void;

  private readonly closeRequest$ = new Subject<void>();

  get onCloseRequest$(): Observable<void> {
    return this.closeRequest$.asObservable();
  }

  private triggerCloseRequest() {
    this.closeRequest$.next();
  }

  // Funciones para emitir los cambios Contratacion
  setFormModal(data: any) {
    this.FormModal$.next(data);
  }

  // Funciones para recibir los cambios Contratacion
  get selectFormModal$(): Observable<any> {
    return this.FormModal$.asObservable();
  }

  setTipo(data: string) {
    this.Tipo$.next(data);
  }

  get selectTipo$(): Observable<string> {
    return this.Tipo$.asObservable();
  }

  // openModal() {
  //   let modalGeneral = document.getElementById('modalGeneral') as any;
  //   if (modalGeneral) {
  //     modalGeneral.style.display = 'block';
  //     modalGeneral.classList.add('show');
  //     modalGeneral.style.backgroundColor = 'rgba(0,0,0,0.5)';
  //     setTimeout(() => {
  //       modalGeneral.style.opacity = 1;
  //     }); //FOR TRANSITION
  //     history.pushState({ modalOpen: true }, '', location.href);
  //   }
  // }

  openModal() {
    const modalGeneral = document.getElementById('modalGeneral') as any;
    if (modalGeneral) {
      modalGeneral.style.display = 'block';
      modalGeneral.classList.add('show');
      modalGeneral.style.backgroundColor = 'rgba(0,0,0,0.5)';
      setTimeout(() => { modalGeneral.style.opacity = 1; });

      if (!history.state?.modalOpen) {
        history.pushState({ modalOpen: true }, '', location.href);
      }

      this.bindPopstate();
    }
  }

  private bindPopstate() {
    // Evitar duplicados
    this.unbindPopstate();

    this.popstateListener = () => {
      if (Swal.isVisible()) {
        Swal.close();
        return;
      }
      // Emitir solicitud al ModalComponent para que muestre la alerta
      this.triggerCloseRequest();
    };

    window.addEventListener('popstate', this.popstateListener);
  }

  private unbindPopstate() {
    if (this.popstateListener) {
      window.removeEventListener('popstate', this.popstateListener);
      this.popstateListener = undefined;
    }
  }

  bindPopstatePublic() {
    this.bindPopstate();
  }

  // Cierra el modal visualmente sin tocar el historial
  // (se usa cuando el popstate ya consumió la entrada)
  private closeSilently() {
    const modalGeneral = document.getElementById('modalGeneral') as any;
    if (modalGeneral) {
      modalGeneral.style.display = 'none';
      modalGeneral.classList.remove('show');
      modalGeneral.style.opacity = 1;
    }
    this.setTipo('clear');
    this.resetFormModal();
    // NO llamar history.back() aquí
  }

  closeSilentlyPublic() {
    this.closeSilently();
  }

  // modal.service.ts
  resetFormModal() {
    this.FormModal$.next({
      formulario: '',
      title: '',
      data: {},
    });
  }

  // closeModal() {
  //   let modalGeneral = document.getElementById('modalGeneral') as any;
  //   if (modalGeneral) {
  //     modalGeneral.style.display = 'none';
  //     modalGeneral.classList.remove('show');
  //     modalGeneral.style.opacity = 1;
  //   }
  //   this.setTipo('clear');
  //   this.resetFormModal()
  //   if (history.state?.modalOpen) {
  //     history.back();
  //   }
  // }

  closeModal() {
    const modalGeneral = document.getElementById('modalGeneral') as any;
    if (modalGeneral) {
      modalGeneral.style.display = 'none';
      modalGeneral.classList.remove('show');
      modalGeneral.style.opacity = 1;
    }
    this.setTipo('clear');
    this.resetFormModal();
    this.unbindPopstate();

    // Reemplaza el estado del modal con uno limpio
    // SIN navegar — solo limpia la entrada del historial
    if (history.state?.modalOpen) {
      history.replaceState({}, '', location.href);
    }
  }

  // Registro de componentes para carga dinámica
  registerComponent(key: string, component: Type<any>) {
    if (!key || !component) return;
    this.registry.set(key, component);
  }

  unregisterComponent(key: string) {
    this.registry.delete(key);
  }

  getRegisteredComponent(key: string): Type<any> | undefined {
    return this.registry.get(key);
  }

}
